import { Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Avatar com fallback padrão.
 *
 * Centraliza o comportamento que estava duplicado em cada tela: exibir a
 * imagem quando existir e cair para um ícone padrão quando a imagem estiver
 * ausente OU falhar ao carregar. O estado de falha é local ao componente, de
 * modo que uma falha de carregamento não altera os dados da tela.
 *
 * Encapsulação: a `<img>` e o `<iconify-icon>` são renderizados por ESTE
 * template, então o SCSS da tela que usa o componente não os alcança (o
 * Angular escopa por atributo). Por isso o componente estiliza a própria
 * imagem, e a caixa do avatar (tamanho, borda, cor) fica no elemento host —
 * que pertence ao template da tela e continua recebendo o CSS dela.
 */
@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  standalone: false
})
export class AvatarComponent implements OnChanges {
  @Input() src?: string | null;
  @Input() alt = '';
  /** Lado da caixa em px. Omitido: o host ocupa 100% do container da tela. */
  @Input() size?: number;
  /** Lado do ícone de fallback em px. Omitido: herda o `font-size` do host. */
  @Input() iconSize?: number;
  @Input() icon = 'mdi:account-circle-outline';

  private failed = false;

  get showImage(): boolean {
    return !!this.src && this.src.trim().length > 0 && !this.failed;
  }

  /** Permite à tela estilizar o estado sem foto (ex.: fundo do placeholder). */
  @HostBinding('class.is-fallback')
  get isFallback(): boolean {
    return !this.showImage;
  }

  @HostBinding('style.width')
  get boxWidth(): string {
    return this.size ? `${this.size}px` : '100%';
  }

  @HostBinding('style.height')
  get boxHeight(): string {
    return this.size ? `${this.size}px` : '100%';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) this.failed = false;
  }

  onError(): void {
    this.failed = true;
  }
}
